import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { StockAmazonRecapPageRoutingModule } from './stock-amazon-recap-routing.module';

import { StockAmazonRecapPage } from './stock-amazon-recap.page';
import { ComponentsModule } from 'src/components/components.module';
import { CommonLibModule } from 'common-lib';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    StockAmazonRecapPageRoutingModule,
    
    ComponentsModule,
    CommonLibModule,
    // VirtualScrollerModule,
  ],
  declarations: [StockAmazonRecapPage]
})
export class StockAmazonRecapPageModule {}
